import React from 'react';

const ExperimentContext = React.createContext({
  experiments: {}
});

export default ExperimentContext;
